// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Jf6M1","text":"Button_text__s5DVv","leftIcon":"Button_leftIcon__F+aAS","rightIcon":"Button_rightIcon__hgVO1"};